/**
 * Dutch holidays — dunne laag over het gedeelde primitief `feestdagen.ts`
 * (drie spiegels, hash-bewaakt via scripts/smoke-workforce.sh). De oude
 * namen blijven bestaan voor WeekGrid, auto-schedule en hours-calculator.
 */
import { feestdagen, feestdagNaam, feestdagenTussen, type Feestdag } from './feestdagen';

export * from './feestdagen';

export type DutchHoliday = Feestdag;

/** Alle feestdagen van een jaar (CAO Schoonmaak). */
export function getDutchHolidays(year: number): DutchHoliday[] {
  return feestdagen(year);
}

/** Feestdag op deze datum (YYYY-MM-DD), anders null. */
export function isHoliday(dateStr: string): DutchHoliday | null {
  const name = feestdagNaam(dateStr);
  return name ? { date: dateStr, name } : null;
}

/** Feestdagen binnen een bereik (inclusief). */
export function getHolidaysInRange(from: string, to: string): DutchHoliday[] {
  return feestdagenTussen(from, to);
}
